'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingScreen = function (_Component) {
  (0, _inherits3.default)(LoadingScreen, _Component);

  function LoadingScreen() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LoadingScreen);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LoadingScreen.__proto__ || (0, _getPrototypeOf2.default)(LoadingScreen)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LoadingScreen, [{
    key: 'render',
    value: function render() {
      var styles = require('../Modules.scss');
      var loading = require('./loading.gif');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.centerScreen },
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 4, sm: 2, xs: 2, lg: 4 },
            '\xA0'
          ),
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 4, sm: 8, xs: 8, lg: 4 },
            _react2.default.createElement(
              ReactBootstrap.Panel,
              null,
              _react2.default.createElement(
                'div',
                { className: styles.textCenter },
                _react2.default.createElement(
                  'h1',
                  null,
                  'Loading...'
                ),
                _react2.default.createElement(ReactBootstrap.Image, { src: loading, responsive: true })
              )
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 4, sm: 2, xs: 2, lg: 4 },
            '\xA0'
          )
        )
      );
    }
  }]);
  return LoadingScreen;
}(_react.Component);

exports.default = LoadingScreen;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingScreen/LoadingScreen.js
// module id = 1151
// module chunks = 0